import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "@/components/ui/sonner";
import KeepApp from "@/pages/KeepApp";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PublicShare from "@/pages/PublicShare";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import SecretNote from "@/pages/SecretNote";
import SendFiles from "@/pages/SendFiles";
import TransferDownload from "@/pages/TransferDownload";
import { AuthProvider } from "@/auth/AuthContext";
import usePointerEventsGuard from "@/lib/usePointerEventsGuard";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Self-hosted Google OAuth client — the ID is public (it's not a secret).
// The Client Secret lives on the backend only.
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<KeepApp />} />
      <Route path="/share/:token" element={<PublicShare />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/secret/:token" element={<SecretNote />} />
      <Route path="/send" element={<SendFiles />} />
      <Route path="/t/:token" element={<TransferDownload />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  usePointerEventsGuard();
  return (
    <div className="App">
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </GoogleOAuthProvider>
      {/* Toaster: bottom-right on desktop; top-center on phones so a
          long "Moved to trash" toast never blocks the floating + FAB. */}
      <Toaster
        richColors
        position={typeof window !== "undefined" && window.matchMedia?.("(max-width: 767px)").matches ? "top-center" : "bottom-right"}
      />
    </div>
  );
}

export default App;
